<div class="dashboard--module-header">
    <h2 class="subheading-sm">Consumers with debt balance<button class="info-btn focus-element" (click)="onInfoClick()"><span class="focus--content" tabindex="-1"><span>i</span></span></button></h2>
</div>
<div class="module--main">
    <issues-billing-aged-debt-chart class="block-chart"></issues-billing-aged-debt-chart>
    <div class="block-detail">
        <table class="std-table stacked-sm" *ngIf="data.length > 0">
            <thead>
            <th>Consumer name</th>
            <th>Supply address</th>
            <th>Account balance</th>
            <th>0-30 days</th>
            <th>30-60 days</th>
            <th>60-90 days</th>
            <th>90-180 days</th>
            <th>180-365 days</th>
            <th>365+ days</th>
            </thead>
            <tbody>
                <tr *ngFor="let item of data">
                    <td data-label="Consumer name">{{item.consumerName}} <div *ngIf="item.isClosed" class="m-ic m-ic--closed" title="Closed: previous consumer of this address">Closed</div></td>
                    <td data-label="Supply address">{{item.consumerAddress}}</td>
                    <td data-label="Account balance">{{item.balance | currency:'GBP'}}</td>
                    <td data-label="0-30 days">{{item.current| currency:'GBP'}}</td>
                    <td data-label="30-60 days">{{item._3060Days | currency:'GBP'}}</td>
                    <td data-label="60-90 days">{{item._6090Days | currency:'GBP'}}</td>
                    <td data-label="90-180 days">{{item._90180Days | currency:'GBP'}}</td>
                    <td data-label="180-365 days">{{item._180365Days | currency:'GBP'}}</td>
                    <td data-label="365+ days">{{item._365Days | currency:'GBP'}}</td>
                    <td class="text-right"><a [routerLink]="['/portal/'+ clientId +'/consumer',item.consumerId]" class="text-link focus-element"><span class="focus--content">View</span></a></td>
                </tr>
            </tbody>
        </table>
        <app-pagination *ngIf="data.length > 0" [page]="page" [pages]="totalPages" (pageChange)="getPage($event)"></app-pagination>
    </div>
</div>
